import React from "react";
import { Link } from "@mui/material";
import { LARAVEL_API_PATH } from "../../../constants/path";
import { useAvailableConsentTypes } from "../../../hooks/useAvailableConsentTypes";

const DataTransferConsentLink: React.FC = () => {
    const { isTypeAvailable } = useAvailableConsentTypes();

    if (!isTypeAvailable('data_transfer_consent')) {
        return null;
    }

    return (
        <Link
            className={'footer__link'}
            href={`${LARAVEL_API_PATH}consent-download/data_transfer_consent`}
            target="_blank"
        >
            Согласие на передачу персональных данных
        </Link>
    );
};

export default DataTransferConsentLink;

